// extracted by mini-css-extract-plugin
export default {"figure":"Card_figure__QQL0e","trend":"Card_trend__9dF0D","divider":"Card_divider__a6BwB"};